export function addHttpIfNeeded(url) {
    if (!/^((http|https):\/\/)/i.test(url)) {
        url = "http://" + url;
    }
    return url;
}